import * as React from 'react';
import {FunctionComponent} from 'react';
import {Report} from '../../../../Models/Report';
import {format} from 'date-fns';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    report: Report;
    className?: string;
}

export const ReportCard: FunctionComponent<OwnProps> = ({report, className}) => {
    return (
        <div className={classNames(className, 'card')}>
            <div className="card-title">
                <h5 className="d-flex justify-content-between align-items-baseline">
                    <a href={'/reports/' + report.id}>{report.name}</a>
                    <span className="fs-6">
                        {report.latestSnippetAt === null
                            ? 'Empty report'
                            : format(report.latestSnippetAt, 'dd-MM-yyyy')}
                    </span>
                </h5>
            </div>
            <div className="card-body">
                <p>{report.description}</p>
                <div className="d-flex gap-1">
                    {[
                        ...report.snippetCollections.map((collection) => ({
                            id: collection.id,
                            name: collection.name,
                        })),
                        ...report.crews.map((crew) => ({
                            id: crew.id,
                            name: crew.name,
                        })),
                        ...report.users.map((user) => ({
                            id: user.id,
                            name: user.displayName,
                        })),
                        {
                            id: report.type,
                            name: report.type,
                        },
                    ].map((item) => (
                        <span key={item.id} className="badge rounded-pill bg-dark">
                            {item.name}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
};
